import adobeCommerce from "@/assets/integrations/adobecommerce.svg";
import algolia from "@/assets/integrations/algolia.svg";
import bigCommerce from "@/assets/integrations/bigcommerce.svg";
import commerceTools from "@/assets/integrations/commercetools.svg";
import klaviyo from "@/assets/integrations/klaviyo.svg";
import magento from "@/assets/integrations/magento.svg";
import marketplacer from "@/assets/integrations/marketplacer.svg";
import newstore from "@/assets/integrations/newstore.svg";
import reviews from "@/assets/integrations/reviews.svg";
import shopify from "@/assets/integrations/shopify.svg";
import airtable from "@/assets/integrations/airtable.svg";
import cegid from "@/assets/integrations/cegid.svg";
import channelengine from "@/assets/integrations/channelengine.svg";
import emarsys from "@/assets/integrations/emarsys.svg";
import googlesheets from "@/assets/integrations/googlesheets.svg";
import gorgias from "@/assets/integrations/gorgias.svg";
import mirakl from "@/assets/integrations/mirakl.svg";
import notion from "@/assets/integrations/notion.svg";
import salesforce from "@/assets/integrations/salesforce.svg";
import sap from "@/assets/integrations/sap.svg";
import shipbob from "@/assets/integrations/shipbob.svg";
import woocommerce from "@/assets/integrations/woocommerce.svg";
import xero from "@/assets/integrations/xero.svg";
import zendesk from "@/assets/integrations/zendesk.svg";

const IntegrationBanner = () => {
  const integrations = [
    { name: "Adobe Commerce", logo: adobeCommerce },
    { name: "Algolia", logo: algolia },
    { name: "BigCommerce", logo: bigCommerce },
    { name: "CommerceTools", logo: commerceTools },
    { name: "Klaviyo", logo: klaviyo },
    { name: "Magento", logo: magento },
    { name: "Marketplacer", logo: marketplacer },
    { name: "Newstore", logo: newstore },
    { name: "Reviews", logo: reviews },
    { name: "Shopify", logo: shopify },
    { name: "Airtable", logo: airtable },
    { name: "Cegid", logo: cegid },
    { name: "ChannelEngine", logo: channelengine },
    { name: "Emarsys", logo: emarsys },
    { name: "Google Sheets", logo: googlesheets },
    { name: "Gorgias", logo: gorgias },
    { name: "Mirakl", logo: mirakl },
    { name: "Notion", logo: notion },
    { name: "Salesforce", logo: salesforce },
    { name: "SAP", logo: sap },
    { name: "ShipBob", logo: shipbob },
    { name: "WooCommerce", logo: woocommerce },
    { name: "Xero", logo: xero },
    { name: "Zendesk", logo: zendesk },
  ];

  // Duplicate the array for infinite scroll effect
  const duplicatedIntegrations = [...integrations, ...integrations];

  return (
    <section className="py-6 bg-muted/20 border-y border-border overflow-hidden" aria-label="Platform integrations">
      <div className="container mx-auto">
        <header className="text-center mb-4">
          <h2 className="text-sm font-medium text-muted-foreground">
            Seamless integrations with 100+ platforms
          </h2>
        </header>
        
        <div className="relative" role="list" aria-label="Integration partners">
          <div className="flex items-center gap-8 animate-scroll">
            {duplicatedIntegrations.map((integration, index) => (
              <div
                key={`${integration.name}-${index}`}
                className="flex-shrink-0 w-24 h-12 flex items-center justify-center group"
                role="listitem"
              >
                <img
                  src={integration.logo}
                  alt={`${integration.name} integration - Connect your commerce platform with ${integration.name}`}
                  className="h-10 w-auto object-contain grayscale brightness-90 opacity-70 group-hover:grayscale-0 group-hover:brightness-100 group-hover:opacity-100 transition-all duration-300"
                  loading="lazy"
                  width={96}
                  height={40}
                />
              </div>
            ))}
          </div>
          
          {/* Gradient overlays for smooth edges */}
          <div className="absolute top-0 left-0 h-full w-20 bg-gradient-to-r from-muted/20 to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 h-full w-20 bg-gradient-to-l from-muted/20 to-transparent pointer-events-none" />
        </div>
      </div>
    </section>
  );
};

export default IntegrationBanner;
